// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__0Nn7c","wideOnMobile":"styles_wideOnMobile__z+pvt"};